import React, { useContext } from 'react'

import Header from '../Layout/Landing/Header'
import Main from '../Layout/Landing/Main'
import Footer from '../Layout/Landing/Footer'
import UIContext from '../context/UIContext'
import Menu from '../components/Menu/Menu'

function LandingScreen() {

    const { isViewMenu } = useContext(UIContext);

    return (

        <>
        
            <Header/>

            <Main/>

            <Footer/>

            {isViewMenu && ( <Menu/> )}

        </>

    )

}

export default LandingScreen